// Maps listing slugs to specific WhatsApp numbers.
// Listings not in this map fall back to the country default from $whatsappNumbers.
const LH_AIA_NUMBER = '573009111255'
const LH_MX_LAP_NUMBER = '525590354299'

export const LH_FALLBACK_NUMBER = '5715110430'
export const LH_MX_FALLBACK_NUMBER = '5215599631419'

export const whatsappListingNumbers: Record<string, string> = {
  almare: LH_AIA_NUMBER,
  'aluna-apartamento': LH_AIA_NUMBER,
  amare: LH_AIA_NUMBER,
  'amantina-torre-3': LH_AIA_NUMBER,
  'baruch-living': LH_AIA_NUMBER,
  'baru-beach': LH_AIA_NUMBER,
  'bivrantti-beach-club': LH_AIA_NUMBER,
  'cala-apartasuites': LH_AIA_NUMBER,
  'canoes-camino-al-mar': LH_AIA_NUMBER,
  'canoes-camino-al-mar-e2': LH_AIA_NUMBER,
  cittadel: LH_AIA_NUMBER,
  'civita-apartamento': LH_AIA_NUMBER,
  'costa-serrana': LH_AIA_NUMBER,
  dunna: LH_AIA_NUMBER,
  'dunna-e2': LH_AIA_NUMBER,
  'fantasia-apartamentos': LH_AIA_NUMBER,
  hug: LH_AIA_NUMBER,
  'ika-mare': LH_AIA_NUMBER,
  'lagoa-by-loop': LH_AIA_NUMBER,
  'malecon-72': LH_AIA_NUMBER,
  'malecon-72-torre-3': LH_AIA_NUMBER,
  'playa-escondida': LH_AIA_NUMBER,
  'playa-escondida-etapa-2': LH_AIA_NUMBER,
  'playa-santua-torre-mar-1-y-2': LH_AIA_NUMBER,
  puntamar: LH_AIA_NUMBER,
  'reserva-del-mar-bello-horizonte-3': LH_AIA_NUMBER,
  'reserva-del-mar-puerto-gaira': LH_AIA_NUMBER,
  'santa-marina-e7': LH_AIA_NUMBER,
  'santa-marina-macro-etapa-6': LH_AIA_NUMBER,
  serraviva: LH_AIA_NUMBER,
  szenza: LH_AIA_NUMBER,
  'the-somos-frame': LH_AIA_NUMBER,
  'xua-apartamentos-apartamento': LH_AIA_NUMBER,
  'xua-santa-marta': LH_AIA_NUMBER,
  'xua-santa-marta-etapa-2': LH_AIA_NUMBER,
  cuau1149: LH_MX_LAP_NUMBER,
  hauspace: LH_MX_LAP_NUMBER
}
